import { render } from "./Singer.vue?vue&type=template&id=40bdd542"
import script from "./Singer.vue?vue&type=script&lang=js"
export * from "./Singer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__